import React from 'react';
import { Layout } from 'fronton-react';
import { Banner, OtherSection, RootLayout } from 'common/components';
import { PromoBlock } from 'remotes/promo-block';
import { SpecialOffer } from 'remotes/special-offer';
import {
  BATHROOM_COLLECTIONS_DESIGN_BANNER_STRUCTURE,
  BATHROOM_COLLECTIONS_ELEMENT_BLOCK,
  BATHROOM_COLLECTIONS_LANDING_NAME,
  BATHROOM_COLLECTIONS_PATH,
} from './bathroom-collections-constants';
import {
  BathroomCollectionsHeader,
  BathroomCollectionsList,
  BathroomCollectionsStepsSection,
} from './components';

export const BathroomCollections = () => (
  <RootLayout currentPage={BATHROOM_COLLECTIONS_PATH}>
    <Layout>
      <BathroomCollectionsHeader />
      <PromoBlock elementBlock={BATHROOM_COLLECTIONS_ELEMENT_BLOCK} />
      <SpecialOffer elementBlock={BATHROOM_COLLECTIONS_ELEMENT_BLOCK} />
      <BathroomCollectionsList />
      <Banner {...BATHROOM_COLLECTIONS_DESIGN_BANNER_STRUCTURE} />
      <BathroomCollectionsStepsSection />
    </Layout>
    <OtherSection
      elementBlock={`${BATHROOM_COLLECTIONS_ELEMENT_BLOCK} / other`}
      landingName={BATHROOM_COLLECTIONS_LANDING_NAME}
      promotionName={`${BATHROOM_COLLECTIONS_ELEMENT_BLOCK}_bottom`}
    />
  </RootLayout>
);
